import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Header.scss';
import Logo from './Logo';

export default class Header extends Component {
  render() {
    return (
      <div className="hb-header">
        <Logo />
        {this.props.children}
      </div>
    );
  }
}

Header.propTypes = {
  children: PropTypes.node,
};

Header.defaultProps = {
  children: [],
};
